const bookmarkBold = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><polygon points="3 1 3 15 8.01 11.13 13 15 13 1"/></svg>',
};

export { bookmarkBold as default };
